import { useCallback } from "react";
import api from "@/lib/api";

export function useInvoicePDF() {
  const generatePDF = useCallback(async (quoteId) => {
    try {
      const { data } = await api.get(`/api/quotes/${quoteId}/pdf-data`);
      const { quote, customer, company } = data;
      const win = window.open("", "_blank");
      if (!win) return;
      const items = (quote.items || []).map((item, i) => `
        <tr>
          <td style="padding:8px 12px;border-bottom:1px solid #e2e8f0;font-size:13px">${i + 1}</td>
          <td style="padding:8px 12px;border-bottom:1px solid #e2e8f0">
            <span style="font-size:9px;padding:2px 6px;border-radius:4px;font-weight:600;${item.type === 'subscription' ? 'background:#dbeafe;color:#1d4ed8' : item.type === 'addon' ? 'background:#dcfce7;color:#15803d' : 'background:#f1f5f9;color:#475569'}">${item.type === 'subscription' ? 'PLAN' : item.type === 'addon' ? 'ADD-ON' : 'CUSTOM'}</span>
            <span style="margin-left:8px;font-size:13px">${item.name}</span>
          </td>
          <td style="padding:8px 12px;border-bottom:1px solid #e2e8f0;text-align:right;font-weight:600;font-size:13px">$${item.price?.toFixed(2)}</td>
        </tr>
      `).join("");

      win.document.write(`<!DOCTYPE html><html><head><title>Invoice #${quote.id?.slice(0, 8)} - ShopAdvisor</title>
        <style>
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body { font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif; color: #0f172a; padding: 40px; max-width: 800px; margin: 0 auto; }
          @media print { body { padding: 20px; } .no-print { display: none !important; } }
        </style>
      </head><body>
        <div class="no-print" style="margin-bottom:20px;text-align:right">
          <button onclick="window.print()" style="background:#2563eb;color:#fff;border:none;padding:10px 24px;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer">Print / Save PDF</button>
          <button onclick="window.close()" style="background:#e2e8f0;color:#475569;border:none;padding:10px 24px;border-radius:8px;font-size:14px;cursor:pointer;margin-left:8px">Close</button>
        </div>
        <div style="display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:32px">
          <div>
            <h1 style="font-size:28px;font-weight:900;color:#0f172a;margin-bottom:4px">${company.name}</h1>
            <p style="font-size:12px;color:#64748b">${company.tagline}</p>
            <p style="font-size:12px;color:#2563eb">${company.website}</p>
          </div>
          <div style="text-align:right">
            <h2 style="font-size:22px;font-weight:800;color:#2563eb;margin-bottom:4px">INVOICE</h2>
            <p style="font-size:12px;color:#64748b">#${quote.id?.slice(0, 8).toUpperCase()}</p>
            <p style="font-size:12px;color:#64748b">Date: ${quote.created_at?.split("T")[0] || "N/A"}</p>
            <p style="font-size:11px;margin-top:4px;padding:3px 10px;border-radius:12px;display:inline-block;font-weight:600;${quote.status === 'accepted' ? 'background:#dcfce7;color:#15803d' : 'background:#fef9c3;color:#a16207'}">${quote.status?.toUpperCase()}</p>
          </div>
        </div>
        ${customer ? `<div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:16px;margin-bottom:24px">
          <p style="font-size:11px;color:#94a3b8;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px;font-weight:700">Bill To</p>
          <p style="font-size:15px;font-weight:700;color:#0f172a">${customer.name || ""}</p>
          ${customer.business_name ? `<p style="font-size:13px;color:#475569">${customer.business_name}</p>` : ""}
          ${customer.email ? `<p style="font-size:12px;color:#64748b">${customer.email}</p>` : ""}
        </div>` : ""}
        <table style="width:100%;border-collapse:collapse;margin-bottom:24px">
          <thead><tr style="background:#f1f5f9">
            <th style="padding:10px 12px;text-align:left;font-size:11px;color:#64748b;text-transform:uppercase;letter-spacing:0.5px;font-weight:700;width:40px">#</th>
            <th style="padding:10px 12px;text-align:left;font-size:11px;color:#64748b;text-transform:uppercase;letter-spacing:0.5px;font-weight:700">Description</th>
            <th style="padding:10px 12px;text-align:right;font-size:11px;color:#64748b;text-transform:uppercase;letter-spacing:0.5px;font-weight:700;width:120px">Amount</th>
          </tr></thead>
          <tbody>${items}</tbody>
        </table>
        <div style="display:flex;justify-content:flex-end;margin-bottom:24px">
          <div style="width:240px;border:2px solid #2563eb;border-radius:8px;padding:16px;text-align:right">
            <p style="font-size:12px;color:#64748b;margin-bottom:4px">Total Due</p>
            <p style="font-size:28px;font-weight:900;color:#2563eb">$${quote.total?.toFixed(2)}</p>
          </div>
        </div>
        ${quote.notes ? `<div style="background:#f8fafc;border:1px solid #e2e8f0;border-radius:8px;padding:16px;margin-bottom:24px">
          <p style="font-size:11px;color:#94a3b8;text-transform:uppercase;letter-spacing:1px;margin-bottom:6px;font-weight:700">Notes & Terms</p>
          <p style="font-size:13px;color:#475569;white-space:pre-wrap">${quote.notes}</p>
        </div>` : ""}
        <div style="text-align:center;padding-top:24px;border-top:1px solid #e2e8f0">
          <p style="font-size:11px;color:#94a3b8">${company.name} &middot; ${company.website}</p>
        </div>
      </body></html>`);
      win.document.close();
    } catch { }
  }, []);

  return { generatePDF };
}
